var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02 19.7502C8.16 19.7502 7.3 19.3403 6.48 18.5203L2.47 14.5103C1.66 13.7003 1.25 12.8502 1.25 11.9702C1.25 11.1002 1.66 10.2402 2.47 9.43024L9.15 2.75024C9.29 2.61024 9.48 2.53027 9.68 2.53027C9.88 2.53027 10.07 2.61024 10.21 2.75024L17.56 10.1002C17.88 10.4202 18.06 10.8402 18.06 11.3002C18.06 11.7502 17.88 12.1802 17.56 12.5002L11.54 18.5203C10.74 19.3403 9.88 19.7502 9.02 19.7502ZM9.69 4.35022L3.54 10.5002C3.02 11.0202 2.76 11.5202 2.76 11.9802C2.76 12.4402 3.02 12.9402 3.54 13.4502L7.55 17.4602C8.6 18.5102 9.45 18.5102 10.5 17.4602L16.52 11.4402C16.58 11.3802 16.59 11.2302 16.52 11.1602L9.69 4.35022Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68906 4.03964C9.49906 4.03964 9.30906 3.96967 9.15906 3.81967L7.81906 2.47965C7.52906 2.18965 7.52906 1.70965 7.81906 1.41965C8.10906 1.12965 8.58906 1.12965 8.87906 1.41965L10.2191 2.75968C10.5091 3.04968 10.5091 3.52967 10.2191 3.81967C10.0691 3.96967 9.87906 4.03964 9.68906 4.03964Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0712 12.6697C1.6712 12.6697 1.3412 12.3597 1.3212 11.9497C1.3012 11.5397 1.6212 11.1897 2.0412 11.1697L17.1712 10.5097C17.5812 10.4897 17.9312 10.8096 17.9512 11.2296C17.9712 11.6396 17.6512 11.9897 17.2312 12.0097L2.1012 12.6697C2.0912 12.6697 2.0812 12.6697 2.0712 12.6697Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.75H3C2.59 22.75 2.25 22.41 2.25 22C2.25 21.59 2.59 21.25 3 21.25H16C16.41 21.25 16.75 21.59 16.75 22C16.75 22.41 16.41 22.75 16 22.75Z",
    fill: "#292D32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.85 20.83C17.42 20.83 16.25 19.6601 16.25 18.2301C16.25 16.7801 17.96 14.8601 18.3 14.4801C18.58 14.1701 19.12 14.1701 19.4 14.4801C19.74 14.8501 21.45 16.77 21.45 18.22C21.45 19.67 20.28 20.83 18.85 20.83ZM18.85 16.1701C18.3 16.8901 17.75 17.7701 17.75 18.2401C17.75 18.8501 18.24 19.34 18.85 19.34C19.46 19.34 19.95 18.8501 19.95 18.2401C19.95 17.7601 19.4 16.8801 18.85 16.1701Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBucket);
export default __webpack_public_path__ + "static/media/bucket.5f70e6867f2039a0aad1c97dde1a0397.svg";
export { ForwardRef as ReactComponent };